import React from 'react';
import { ToastContainer } from 'react-toastify';
import ReportingSalesPacksPage from '../components/ReportingSalesPacksPage';

const ReportingSalesPacksApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <ReportingSalesPacksPage {...props} />
  </>
);

export default ReportingSalesPacksApp;
